// utils/imageUrl.js
export const getImageUrl = (path) => {
    if (!path) return '/placeholder-receipt.jpg';
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${cleanPath.startsWith('uploads/') ? '' : 'uploads/'}${cleanPath}`;
  };